import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Bookings from '@/views/Bookings.vue'
import Hoops5x5Challenge from '@/views/Hoops5x5Challenge.vue'
import Leagues from '@/views/Leagues.vue'
import Sponsors from '@/views/Sponsors.vue'
import Corporate from '@/views/Corporate.vue'
import RecordView from '@/views/RecordView.vue'
const router = {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/nosotros',
      name: 'About',
      component: About
    },
    {
      path: '/canchas',
      name: 'Bookings',
      component: Bookings
    },
    {
      path: '/hoops-5x5-challenge',
      name: 'Hoops5x5Challenge',
      component: Hoops5x5Challenge
    },
    {
      path: '/ligas-y-torneos',
      name: 'Leagues',
      component: Leagues
    },
    {
      path: '/sponsors',
      name: 'Sponsors',
      component: Sponsors
    },
    {
      path: '/corporate',
      name: 'Corporate',
      component: () => Corporate
    },
    {
      path: '/db-works',
      name: 'dbWorks',
      component: () => import(/* webpackChunkName: "tmp" */ './views/DBWorks.vue'),
      meta: {
        authRequired: ['admin']
      }
    },
    {
      path: '/su-reserva/:id',
      name: 'RecordView',
      component: RecordView
    },
    {
      path: '/bookings',
      name: 'BookingsView',
      component: () => import(/* webpackChunkName: "hy" */ './views/bookings/View.vue'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "hy" */ './views/bookings/Booking.vue'),
          children: [
            {
              path: 'day/:day',
              name: 'BookingsViewDay',
              component: () => import(/* webpackChunkName: "hy" */ './views/bookings/DayView.vue')
            },
            {
              path: 'month/:day',
              name: 'BookingsViewWeek',
              component: () => import(/* webpackChunkName: "hy" */ './views/bookings/WeekView.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/cash-machine/',
      redirect: '/admin/login'
    },
    {
      path: '/cash-machine/login',
      redirect: '/admin/login'
    },
    {
      path: '/estimation-print',
      name: 'EstimationPrint',
      component: () => import(/* webpackChunkName: "hy" */ './views/estimates/Print.vue')
    },
    {
      path: '/admin/login',
      name: 'CashRegisterLogin',
      component: () => import(/* webpackChunkName: "hy" */ './views/cash/Login.vue')
    },
    {
      path: '/admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/cash/Cash.vue'),
      meta: {
        authRequired: ['team', 'admin']
      },
      children: [
        {
          path: '',
          name: 'CashRegister',
          component: () => import(/* webpackChunkName: "admin" */ './views/cash/register/View.vue')
        },
        {
          path: 'edit/:id?',
          name: 'EditRecord',
          component: () => import(/* webpackChunkName: "admin" */ './views/cash/EditRecord.vue')
        },
        {
          path: 'products',
          meta: {
            authRequired: ['admin']
          },
          component: () => import(/* webpackChunkName: "admin" */ './views/products/View.vue'),
          children: [
            {
              path: '',
              name: 'Products',
              component: () => import(/* webpackChunkName: "admin" */ './views/products/List.vue')
            },
            {
              path: 'edit/:productId?',
              name: 'ProductEdit',
              component: () => import(/* webpackChunkName: "admin" */ './views/products/Edit.vue')
            }
          ]
        },
        {
          path: 'estimation',
          name: 'Estimation',
          component: () => import(/* webpackChunkName: "hy" */ './views/estimates/Edit.vue')
        },
        {
          path: 'history',
          component: () => import(/* webpackChunkName: "admin" */ './views/cash/history/View.vue'),
          meta: {
            authRequired: ['admin']
          },
          children: [
            {
              path: '',
              name: 'HistoryDashboard',
              component: () => import(/* webpackChunkName: "admin" */ './views/cash/history/Dashboard.vue')
            },
            {
              path: 'days',
              name: 'HistoryDays',
              component: () => import(/* webpackChunkName: "admin" */ './views/cash/history/Days.vue')
            }
          ]
        }
      ]
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "notfound" */ './views/NotFound.vue')
    }
  ],
  scrollBehavior () {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  }
}
export default router
